import { isUnstableSignal } from "@opus-dt/shared-types";
import { Pill } from "@/components/ui/pill";
import type { AttentionOccurrence } from "@/types/attention.types";
import { ALARM_UNSTABLE_REASON } from "@/lib/display-labels";
import { ATTENTION_STATUS_META } from "./occurrence-meta";

// Ocorrência "instável": fonte oscilando ou confiabilidade suspeita (shared).
function isUnstable(occ: AttentionOccurrence): boolean {
  return occ.alarm ? isUnstableSignal(occ.alarm) : false;
}

// Bloco de badges da ocorrência (instável + statuses), antes copiado
// verbatim em 4 telas (card, modal, sidebar, /alarms). `resolvedFallback` mostra
// "Resolvido" quando não há status pendente (visão de histórico da /alarms).
export function OccurrenceStatusPills({
  occ,
  resolvedFallback = false,
}: {
  occ: AttentionOccurrence;
  resolvedFallback?: boolean;
}) {
  if (occ.statuses.length === 0 && resolvedFallback && !isUnstable(occ)) {
    return (
      <Pill tone="success" withDot>
        Resolvido
      </Pill>
    );
  }
  return (
    <>
      {isUnstable(occ) ? (
        <Pill tone="warning" withDot title={ALARM_UNSTABLE_REASON}>
          Instável
        </Pill>
      ) : null}
      {occ.statuses.map((s) => (
        <Pill key={s} tone={ATTENTION_STATUS_META[s].tone} withDot>
          {ATTENTION_STATUS_META[s].label}
        </Pill>
      ))}
    </>
  );
}
